import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import logo from "../images/logo.png";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        borderBottom: '2px solid #ffffff17',
        marginBottom: theme.spacing(3),
        backgroundImage: 'linear-gradient(to bottom, #000c23, #022158, #03286b, #000c23)',
        textAlign : "center"
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        color: 'white',
        fontSize: "30px"
    },
}));

export default function CustomAppBar() {
    const classes = useStyles();

    return (
        <div>
            <AppBar position="static" className={classes.root}>
                <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                        <img src={logo} height={45} alt="logo" />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        BitAzure Payment Gateway
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );
}